
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26.97 20.39"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.89 20.39A2.63 2.63 0 018 19.62L.76 12.37a2.64 2.64 0 010-3.7 2.62 2.62 0 013.7 0L9.82 14 22.47.81a2.61 2.61 0 113.78 3.61l-14.5 15.16a2.66 2.66 0 01-1.86.81zM2.61 8.91a1.61 1.61 0 00-1.14 2.75l7.25 7.25a1.6 1.6 0 001.14.48 1.66 1.66 0 001.14-.5L25.53 3.73a1.62 1.62 0 00-2.34-2.23l-13.35 14-6.08-6.12a1.6 1.6 0 00-1.15-.47z","fill":"#666"}})])
          )
        }
      }
    